<template>
  <div class="gs-info-step">
    <gs-card class="gs-wizard-card gs-info-step__card gs-info-step__card--overview">
      <div class="gs-info-step__top-grid">
        <div class="gs-info-step__form">
          <gs-field class="gs-info-step__field" :label="$t('frontend_product_step1_product_name')">
              <text-input v-model="localModel.name" :validator="$v.localModel.name"
                :attribute="$t('frontend_product_step1_product_name')" value="localModel.name"
                :placeholder="$t('frontend_product_step1_product_name')" />
          </gs-field>
          <gs-field class="gs-info-step__field" :label="$t('frontend_product_step1_internal_name')">
              <text-input v-model="localModel.internal_name" :validator="$v.localModel.internal_name"
                :attribute="$t('frontend_product_step1_internal_name')" value="localModel.internal_name"
                :placeholder="$t('frontend_product_step1_internal_name')" />
          </gs-field>
          <gs-field class="gs-info-step__field" :label="$t('frontend_product_step1_description')">
              <text-area v-model="localModel.description" :validator="$v.localModel.description"
                :attribute="$t('frontend_product_step1_description')" value="localModel.description"
                :placeholder="$t('frontend_product_step1_description')" />
          </gs-field>
        </div>

        <aside class="gs-info-step__image-panel">
          <h2 id="gs-info-product-thumbnail-title">Product Image</h2>
          <button
            :key="imagePickerKey"
            type="button"
            class="gs-info-step__upload"
            @click="showImageSelectionModal"
          >
            <img
              v-if="localModel.checkout_page_options.product_image"
              :src="localModel.checkout_page_options.product_image"
              alt=""
            />
            <span v-else class="gs-info-step__upload-empty">
              <gs-icon name="image" size="22"></gs-icon>
              <span>Add image</span>
              <small>Recommended square image</small>
            </span>
            <span class="gs-info-step__upload-overlay">
              {{ localModel.checkout_page_options.product_image ? 'Change' : 'Choose image' }}
            </span>
          </button>
        </aside>
      </div>

      <div class="gs-info-step__type-section">
        <label class="gs-info-step__section-label">Product type</label>
        <div class="gs-info-step__types">
          <label
            v-for="productType in productTypes"
            :key="productType.id"
            class="gs-info-step__type"
            :class="{ 'is-selected': localModel.type === productType.id }"
          >
            <input
              v-model="localModel.type"
              type="radio"
              :value="productType.id"
            >
            <span class="gs-info-step__type-dot"></span>
            <span>
              <strong>{{ productType.title }}</strong>
              <small>{{ productType.description }}</small>
            </span>
          </label>
        </div>
      </div>

    </gs-card>

    <gs-drawer v-model="showProductImagePicker" title="Choose product image" size="xl">
      <image-picker-without-modal
        :value="localModel.checkout_page_options.product_image"
        modal="true"
        remove="false"
        @close-modal="showProductImagePicker = false"
        @selected="setProductImage"
      ></image-picker-without-modal>
    </gs-drawer>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import ImagePickerWithoutModal from '@groovepages/gd-ui-kit/components/ImagePicker';

export default {
  name: 'Step1',
  props: {
    model: {
      required: true,
    },
    gatewayCheckBox: {
      required: true,
    },
    gatewayIntegrations: {
      required: true,
    },
  },
  components: {
    ImagePickerWithoutModal,
  },
  data() {
    return {
      imagePickerKey: 1,
      localModel: this.model,
      localGatewayCheckBox: this.gatewayCheckBox,
      localGatewayIntegrations: this.gatewayIntegrations,
      selectedPaypalGatewayAccount: 0,
      selectedCardGatewayAccount: 0,
      showProductImagePicker: false,
      productTypes: [
        {
          id: 1,
          title: this.$t('frontend_product_step1_frontend_product'),
          description: this.$t('frontend_product_step1_this_will_be_frontend'),
        },
        {
          id: 2,
          title: this.$t('frontend_product_step1_upsell_downsell'),
          description: this.$t('frontend_product_step1_this_will_be_backend'),
        },
        {
          id: 3,
          title: this.$t('frontend_product_step1_order_bump'),
          description: this.$t(
            'frontend_product_step1_this_will_be_order_bump'
          ),
        },
      ],
    };
  },
  validations: {
    localModel: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(80),
      },
      internal_name: {
        minLength: minLength(3),
        maxLength: maxLength(500),
      },
      description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(160),
      },
    },
  },
  computed: {
    paypalIntegrations() {
      return this.localGatewayIntegrations.filter((integration) => {
        return integration.platform == 'paypal';
      });
    },

    cardIntegrations() {
      return this.localGatewayIntegrations.filter((integration) => {
        return integration.platform != 'paypal';
      });
    },

    paypalAddedAccounts() {
      return this.localModel.paypal_processing_accounts.map((a) => a.id);
    },

    cardAddedAccounts() {
      return this.localModel.credit_card_processing_accounts.map((a) => a.id);
    },
  },
  watch: {
    localModel: {
      deep: true,
      handler() {
        this.$emit('updateModel', this.localModel);
      },
    },

    localGatewayCheckBox() {
      this.$emit('updateGatewayCheckbox', this.localGatewayCheckBox);
    },
  },
  created() { },
  methods: {
    showImageSelectionModal() {
      this.showProductImagePicker = true;
    },

    setProductImage(value) {
      this.localModel.checkout_page_options.product_image = value;
      this.imagePickerKey = this.imagePickerKey + 1;
      this.showProductImagePicker = false;
    },
    getHex() {
      let rgb = window.getComputedStyle(document.documentElement).getPropertyValue(`--vs-${this.color}`);
      rgb = rgb.split(',');
      return `#${((1 << 24) +(Number(rgb[0]) << 16) +(Number(rgb[1]) << 8) +Number(rgb[2]))
        .toString(16)
        .slice(1)}`;
    },

    setGatewayCheckbox(gateway) {
      this.localGatewayCheckBox = gateway;
    },

    onlyNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },

    integrationName(id) {
      const integration = this.localGatewayIntegrations.find((obj) => {
        return obj.id === id;
      });

      return integration.platform === 'commas'
        ? 'ScaleGG Pay'
        : integration.name;
    },

    addPaypalGateway() {
      const self = this;
      this.localModel.paypal_processing_accounts.push({
        id: self.selectedPaypalGatewayAccount,
        weightage: 0,
      });

      self.selectedPaypalGatewayAccount = 0;
    },

    deletePaypalGateway(id) {
      this.localModel.paypal_processing_accounts =
        this.localModel.paypal_processing_accounts.filter(
          (obj) => obj.id !== id
        );
    },

    addCardGateway() {
      const self = this;
      this.localModel.credit_card_processing_accounts.push({
        id: self.selectedCardGatewayAccount,
        weightage: 0,
      });

      self.selectedCardGatewayAccount = 0;
    },

    deleteCardGateway(id) {
      this.localModel.credit_card_processing_accounts =
        this.model.credit_card_processing_accounts.filter(
          (obj) => obj.id !== id
        );
    },

    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },
};
</script>

<style>
.gs-info-step {
  display: flex;
  flex-direction: column;
  gap: 10px;
}


.gs-info-step__top-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: 34px;
  align-items: start;
}

.gs-info-step__form {
  min-width: 0;
}

.gs-info-step__field {
  margin-bottom: 16px;
}

.gs-info-step__field label {
  display: block;
  margin-bottom: 7px;
  color: var(--gs-foreground);
  font-size: 12px;
  font-weight: 600;
}

.gs-info-step__field textarea {
  min-height: 86px;
}

.gs-info-step__image-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
  text-align: center;
}

.gs-info-step__card h2 {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}

#gs-info-product-thumbnail-title {
  margin: 0;
  color: var(--gs-foreground);
  font-size: 15px;
  font-weight: 650;
  line-height: 1.35;
  letter-spacing: 0;
}

.gs-info-step__card p {
  margin: 8px 0 16px;
  color: var(--gs-muted-foreground);
  font-size: 11px;
}

.gs-info-step__upload {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  margin-top: 12px;
  overflow: hidden;
  border: 0;
  border-radius: 999px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  box-shadow: var(--gs-shadow-md);
  cursor: pointer;
}

.gs-info-step__upload img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
}

.gs-info-step__upload-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--gs-muted-foreground);
  font-size: 11px;
}

.gs-info-step__upload-empty span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 55px;
  min-height: 24px;
  margin-bottom: 6px;
  color: var(--gs-primary-foreground);
  font-size: 10px;
  font-weight:500;
  border-radius: var(--gs-radius-sm);
  background: var(--gs-primary);
}

.gs-info-step__upload-empty small {
  font-size: 10px;
}

.gs-info-step__upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gs-primary-foreground);
  font-size: 13px;
  font-weight: 600;
  background: rgba(23, 27, 63, .72);
  opacity: 0;
  transition: opacity .16s ease;
}

.gs-info-step__upload:hover .gs-info-step__upload-overlay,
.gs-info-step__upload:focus .gs-info-step__upload-overlay {
  opacity: 1;
}

.gs-info-step__type-section {
  margin-top: 6px;
  padding-top: 18px;
  border-top: 1px solid var(--gs-border);
}

.gs-info-step__section-label {
  display: block;
  margin-bottom: 10px;
  color: var(--gs-foreground);
  font-size: 12px;
  font-weight: 600;
}

.gs-info-step__types {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.gs-info-step__type {
  display: flex;
  align-items: flex-start;
  min-height: 104px;
  padding: 15px 16px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  cursor: pointer;
}

.gs-info-step__type.is-selected {
  background: var(--gs-active-soft);
  border-color: var(--gs-active);
  box-shadow: 0 0 0 3px var(--gs-active-shadow);
}

.gs-info-step__type input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.gs-info-step__type-dot {
  display: inline-block;
  flex: 0 0 auto;
  width: 15px;
  height: 15px;
  margin: 2px 13px 0 0;
  border: 1px solid var(--gs-border-strong);
  border-radius: 999px;
  background: var(--gs-surface);
}

.gs-info-step__type.is-selected .gs-info-step__type-dot {
  border: 4px solid var(--gs-active);
}

.gs-info-step__type strong {
  display: block;
  margin-bottom: 4px;
  color: var(--gs-foreground);
  font-size: 15px;
  font-weight: 650;
}

.gs-info-step__type small {
  display: block;
  color: var(--gs-muted-foreground);
  font-size: 11px;
  line-height: 1.45;
}

@media (max-width: 900px) {
  .gs-info-step__top-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .gs-info-step__image-panel {
    align-items: flex-start;
    padding-top: 0;
    text-align: left;
  }

  .gs-info-step__types {
    grid-template-columns: 1fr;
  }
}
</style>
